var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTop = function SvgTop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dTOP)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 27,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1429 27.8C29.4271 27.8 28.8 28.313 28.8 29C28.8 29.687 29.4271 30.2 30.1429 30.2H43.8571C44.5729 30.2 45.2 29.687 45.2 29C45.2 28.313 44.5729 27.8 43.8571 27.8H30.1429Z",
    fill: "#FF5E6D",
    stroke: "#FF5E6D",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9625 32.1437C37.7096 31.9218 37.3714 31.8005 37.0233 31.8001C36.6751 31.7996 36.3365 31.9199 36.0829 32.1411L29.2045 38.1411C28.6664 38.6105 28.6649 39.3854 29.2016 39.8564C29.7225 40.3137 30.5587 40.3147 31.0812 39.859L37.0183 34.68L42.9158 39.8564C43.4368 40.3137 44.273 40.3147 44.7955 39.859C45.3336 39.3896 45.3351 38.6148 44.7984 38.1437L37.9625 32.1437Z",
    fill: "#FF5E6D",
    stroke: "#FF5E6D",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2 34.0001C38.2 33.3373 37.6627 32.8001 37 32.8001C36.3373 32.8001 35.8 33.3373 35.8 34.0001V46.0001C35.8 46.6628 36.3373 47.2001 37 47.2001C37.6627 47.2001 38.2 46.6628 38.2 46.0001V34.0001Z",
    fill: "#FF5E6D",
    stroke: "#FF5E6D",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dTOP",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Top.57e5324abd4557a5898f2e08175ac3ec.svg";